import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Loading } from '@salesperformanceint/e4shared';
import BlobImage from 'components/blobImage';
import TaskIcon from 'views/user/task/components/taskIcon';
import { e4Format, e4Formats } from 'helpers/dates';

export const SharedObjectivesModal = ({ data, st }) => {
    if (!data) return <Loading />;
    const staff = data.reduce((a, d) => (a.some(y => y.profile_Id === d.profile_Id) ? a : a.concat([d])), []);
    return (
        <div>
            {staff.map(s => {
                return (
                    <div key={`profile-${s.profile_Id}`} className="flex flex-top mb10">
                        <BlobImage
                            height="30"
                            className="img-circle mr10"
                            folder="avatar"
                            src={s.avatar}
                            initials={s.initials}
                        />
                        <div className="flex-grow">
                            <div className="mb5">
                                <span className="mr10 text-lg">
                                    <Link to={`/search/${s.full_Name}`}>{s.full_Name}</Link>
                                </span>
                            </div>
                            {data
                                .filter(d => d.profile_Id === s.profile_Id)
                                .map(d => (
                                    <div key={`task-${s.id}`} className="flex flex-top mb5">
                                        <i className="fa fa-calendar mr10 mt10 text-lg" />
                                        <div className="flex-grow">
                                            <Link to={`/objectives/${d.profile_Id}/objective/${d.id}`}>{d.name}</Link>
                                            <TaskIcon icons={d.icons} />
                                            <div>
                                                {st('Completed')}: {e4Format(d.date_Completed)}
                                            </div>
                                            <div>
                                                {st('Shared')}: {d.other_Full_Name}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default withRouter(SharedObjectivesModal);
